import axios from "axios";
import store from "../store";
import router, { route } from "../router";
import { Loading, message } from "element-ui";
import { envVersion } from "./config";
// import Vue from "vue";
// 创建axios实例
// export const baseURL = "https://login.cdn-design.com";
export const baseURL = envVersion().baseUrl;
const service = axios.create({
  baseURL,
  timeout: 1801000, // 请求超时时间(因为需要调试后台,所以设置得比较大)
  token: "",
});

/** 定义默认配置 */
// service.defaults.baseURL = '/api';
// service.defaults.header = 'Access-Control-Allow-Origin';
service.defaults.headers = {
  "Content-Type": "application/json;charset=UTF-8",
  token: "",
};
// request拦截器,在请求之前做一些处理
service.interceptors.request.use(
  (config) => {
    let token = store.state.checked
      ? store.state.userInfo.token
      : sessionStorage.getItem("cdntoken");

    try {
      let url_parmas_token = GetQueryString("token");
      if (url_parmas_token) {
        token = url_parmas_token;
      }
    } catch (error) {
      console.log(error);
    }

    if (token) {
      // console.log(route.query);
      // const token = store.state.userInfo.token;
      // 给请求头添加laohu-token
      config.headers["token"] = token;
    }
    // if (config.load) {
    // Loading.service({
    //   message: "数据加载中....",
    //   forbidClick: true,
    //   duration: false,
    // });
    // }
    return config;
  },
  (error) => {
    // Loading.clear();
    Promise.reject(error);
  }
);

// response 拦截器,数据返回后进行一些处理
service.interceptors.response.use(
  (response) => {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    const res = response.data;
    if (res.code == 200) {
      // setTimeout(()=>{
      // Loading.clear();
      // },1000)
      return res;
    } else {
      console.log(res, "error");
      switch (res.code) {
        case 400:
          message({
            message: res.msg,
            type: "error",
            customClass: "max-zindex",
            showClose: true,
          });
          return Promise.reject(res.msg);
          break;
        case 401:
          // localStorage.removeItem('token');
          // 修改登陆状态
          store.commit("updateLogin", false);
          store.commit("clearUserInfo");
          // 把用户名存入store
          store.commit("updateUserinfo", "");
          router.push("/login");
          message({
            message: "未授权，请重新登录",
            type: "error",
            showClose: true,
          });
          setTimeout(() => {
            // Loading.clear();
          }, 500);
          return Promise.reject(res.msg);
          break;
        default:
          // res.message = `连接错误${res.code}`;
          return Promise.reject(res.msg);
      }
      return Promise.reject(res.msg);
    }
  },
  (err) => {
    // Loading.fail()
    if (err.response) {
      // Loading.clear()
      switch (err.response.status) {
        case 400:
          err.message = err.response.data.msg;
          // Loading(err.response.data.msg);
          break;
        case 401:
          // localStorage.removeItem('token');
          // 修改登陆状态
          store.commit("updateLogin", false);
          // 把用户名存入store
          store.commit("updateUserinfo", "");
          router.push("/login");
          err.message = "未授权，请重新登录";
          setTimeout(() => {
            // Loading.clear();
          }, 500);
          return Promise.reject(err.response.message);
          break;
        case 403:
          err.message = "拒绝访问";
          break;
        case 404:
          err.message = "请求错误,未找到该资源";
          break;
        case 405:
          err.message = "请求方法未允许";
          break;
        case 408:
          err.message = "请求超时";
          break;
        case 500:
          message({ message: "服务器端出错", type: "error", showClose: true });
          break;
        case 501:
          err.message = "网络未实现";
          break;
        case 502:
          err.message = "网络错误";
          break;
        case 503:
          err.message = "服务不可用";
          break;
        case 504:
          err.message = "网络超时";
          break;
        case 505:
          err.message = "http版本不支持该请求";
          break;
        default:
          err.message = `连接错误${err.response.status}`;
      }
    }
    // if (err.status!=200) {
    //   throw new Error('错误!, 加载并未实现!');
    // }
    setTimeout(() => {
      // Loading.clear();
    }, 500);
    console.log(err, "请求失败");
    message({ message: "服务器繁忙，请稍候再试", showClose: true });
    return Promise.reject("请求失败");
  }
);

function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

export default service;
